import axios from "axios";

import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { PortCall } from "../utils/types/portCalling";

export const fetchPortCallingListData = async () => {
  const response = await axiosServices.get("/portcallings");
  const resData = await response.data;
  return convertToCamelCase<PortCall[]>(resData.data);
};

export const getPortCallingList = async ({
  param: { page, pageSize },
}: {
  param: { page: number; pageSize: number };
}) => {
  const response = await axiosServices.get("/portcallings", {
    params: {
      page: page + 1,
      start: page * pageSize,
      limit: pageSize,
    },
  });
  const resData = await response.data;
  return convertToCamelCase<PortCall[]>(resData.data);
};

export const updatePortCallData = async (
  id: string,
  data: {
    [key: string]: any;
    portCallingsId: string;
  }
) => {
  let inputData;
  if (data.PXPAbbr) {
    inputData = {
      PXP_abbr: data.PXPAbbr,
      port_callings_id: data.portCallingsId,
    };
  } else inputData = convertToSnakeCase(data);
  await axiosServices.put(`/portcallings/${id}`, inputData);
  return {
    success: true,
    data,
  };
};

export const deletePortCallData = async (id: string) => {
  const response = await axiosServices.delete(`/portcallings/${id}`);
  return { success: response.data.success, id };
};

export const addPortCallData = async (data: { [key: string]: any }) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(`/portcallings`, inputData);
  return convertToCamelCase<PortCall>(response.data.data);
};

export const deleteDocuments = async (id: string) => {
  const response = await axiosServices.delete(`/documents/${id}`, {
    data: {
      entity: "portcallings",
      forceDelete: true,
    },
    params: {
      entity: "portcallings",
      forceDelete: true,
    },
  });
  return response.data.success;
};

export const fileUpload = async (file: Blob, type: string, name: string) => {
  const response = await axiosServices.get("/signed_url", {
    params: {
      ContentType: type,
      key: name,
      operation: "put",
    },
  });

  if (response.status !== 200) {
    throw new Error(`Failed to get signed URL: ${response.statusText}`);
  }

  const signedUrl = response.data.data.pre_signed_url;

  const uploadResponse = await axios.put(signedUrl, file, {
    headers: {
      "Content-Type": type,
    },
  });

  if (uploadResponse.status !== 200) {
    throw new Error(`Failed to upload file: ${uploadResponse.statusText}`);
  }

  return {
    success: true,
    fileUrl: signedUrl.split("?")[0], // Return the base URL without query parameters
  };
};

export const addDocumentData = async (
  data: {
    [key: string]: any;
  },
  portCallingId: string
) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(
    `/portcallings/${portCallingId}/document`,
    inputData
  );
  return convertToCamelCase<Document>(response.data.data);
};
